module.exports = __webpack_public_path__ + "static/a-xx-156-art-9043373aa94907fff219b8094f99d1bf.jpg";